<ng-container *ngIf="studentPortal; else portalLoading">
<ng-container *ngIf="currentPortal === 'student'; else legacyAccountCentre">
  <div class="account-centre-page">
    <!-- Desktop Layout Wrapper -->
    <div class="layout-wrapper">
      <!-- Left Sidebar -->
      <aside class="sidebar">
        <h1 class="sidebar-heading">Account Centre</h1>
        <app-account-centre-promo-card></app-account-centre-promo-card>
      </aside>

      <!-- Main Content Area -->
      <main class="main-content">
        <div class="main-header">
          <h2>Manage your account & security</h2>
          <p>Update your personal details and keep your account secure.</p>
        </div>

        <div class="cards-stack">
          <app-personal-info-card></app-personal-info-card>
          <app-parent-details-card></app-parent-details-card>
          <app-password-security-card></app-password-security-card>
          <app-profile-photo-card></app-profile-photo-card>
        </div>
        
        <div class="footer-micro-text">
          GRADPILOTS &middot; SECURE ACCOUNT SESSION &middot; GLOBAL &rarr; GLOBAL APPLICATION TRACK
        </div>
      </main>
    </div>
  </div>
</ng-container>


<ng-template #legacyAccountCentre>
  <div class="container_width flex flex-column gap-4 legacy-container">
    <h1 class="text-left font-medium text-4xl" style="color: #12263F;">Account Centre</h1>
    <div class="w-full grid border-1 border-round-lg" style="border-color: #d0d0d0;">
      <div class="md:col-5 col-12 p-3 flex flex-column gap-3 ">
        <b class="block w-full text-left font-medium text-xl" style="color: #052647;">Account Settings</b>
        <ul class="w-full flex flex-column gap-1">
          <li class="w-full">
            <a (click)="setSelectedTab(tabs.basicInfo)"
              class="w-full flex align-items-center gap-2 p-3 acc_link cursor-pointer" [ngClass]="{'active': selectedTab === tabs.basicInfo}"><i
                class="pi pi-id-card"></i> Personal
              Details</a>
          </li>
          <li class="w-full">
            <a (click)="setSelectedTab(tabs.password)"
              class="w-full flex align-items-center gap-2 p-3 acc_link cursor-pointer" [ngClass]="{'active': selectedTab === tabs.password}"><i
                class="pi pi-shield"></i> Change
              Password</a>
          </li>
          <li class="w-full">
            <a (click)="setSelectedTab(tabs.photos)" class="w-full flex align-items-center gap-2 p-3 acc_link cursor-pointer" [ngClass]="{'active': selectedTab === tabs.photos}"><i
                class="pi pi-image"></i> Update Photos</a>
          </li>
        </ul>
      </div>
      <div class="md:col-7 col-12 md:border-left-1 border-top-1 md:border-top-none  p-3"
        style="border-color: #d0d0d0;">
        <!--Update Basic Info-->
        <app-update-basic-info *ngIf="selectedTab === tabs.basicInfo"></app-update-basic-info>
        <!--Update Password-->
        <app-update-password *ngIf="selectedTab === tabs.password"></app-update-password>
        <!--Update Photos-->
        <app-update-photos *ngIf="selectedTab === tabs.photos"></app-update-photos>
      </div>
    </div>
  </div>
</ng-template>
</ng-container>
<ng-template #portalLoading>
</ng-template>